"use client";

import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyClassAvatars } from "./keyClassAvatars";
import { classAvatarsSchema } from "./schema/classAvatarsSchema";

export const useRequestClassAvatars = ({
  ...props
}: UseRequestQueryProps = {}) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      schema: classAvatarsSchema,
      urlBackendPath: "/class-avatars",
    },
    queryKey: keyClassAvatars(),
  }),
});
